var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 60,
    viewBox: "0 0 168 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_9876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4892 26.5225L22.1736 26.5217C21.4531 26.5217 20.8691 27.1056 20.8691 27.8261V33.0382C20.8691 33.7585 21.4531 34.3426 22.1735 34.3426H31.3615C30.3554 36.9536 28.4776 39.1402 26.0818 40.5296L29.9995 47.3116C36.2841 43.677 39.9995 37.2997 39.9995 30.1608C39.9995 29.1443 39.9246 28.4177 39.7748 27.5995C39.6609 26.9778 39.1212 26.5225 38.4892 26.5225Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9991 42.1739C15.5027 42.1739 11.5774 39.7172 9.46922 36.0818L2.6875 39.9907C6.13867 45.9721 12.6038 50 19.9991 50C23.627 50 27.0502 49.0232 29.9991 47.3209V47.3116L26.0814 40.5296C24.2894 41.569 22.2156 42.1739 19.9991 42.1739Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 47.3209V47.3116L26.0823 40.5295C24.2902 41.5688 22.2166 42.1738 20 42.1738V49.9999C23.6279 49.9999 27.0513 49.0231 30 47.3209Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82609 30C7.82609 27.7837 8.43094 25.7101 9.47008 23.9182L2.68836 20.0093C0.976719 22.9489 0 26.3628 0 30C0 33.6372 0.976719 37.0511 2.68836 39.9907L9.47008 36.0818C8.43094 34.2898 7.82609 32.2163 7.82609 30Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9991 17.8261C22.9313 17.8261 25.6245 18.868 27.7282 20.601C28.2472 21.0285 29.0015 20.9977 29.4769 20.5223L33.1698 16.8293C33.7092 16.2899 33.6708 15.407 33.0946 14.9072C29.57 11.8495 24.9841 10 19.9991 10C12.6038 10 6.13867 14.0279 2.6875 20.0093L9.46922 23.9182C11.5774 20.2828 15.5027 17.8261 19.9991 17.8261Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7291 20.601C28.248 21.0285 29.0024 20.9977 29.4777 20.5223L33.1707 16.8293C33.71 16.2899 33.6716 15.407 33.0955 14.9072C29.5709 11.8494 24.9849 10 20 10V17.8261C22.932 17.8261 25.6254 18.868 27.7291 20.601Z",
    fill: "#D93F21"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_508_9876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.25 28.75H104V11.25C104 10.56 103.44 10 102.75 10H85.25V28.75Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.75 28.75V10H65.25C64.56 10 64 10.56 64 11.25V28.75H82.75Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.75 31.25H64V48.75C64 49.44 64.56 50 65.25 50H82.75V31.25Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.25 31.25V50H102.75C103.44 50 104 49.44 104 48.75V31.25H85.25Z",
    fill: "#FFC107"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.845 16.0792C155.351 14.4679 156.369 12.2308 156.09 10C153.922 10.0774 151.294 11.2728 149.737 12.884C148.342 14.3104 147.12 16.59 147.446 18.777C149.866 18.9407 152.338 17.6879 153.845 16.0792ZM158.463 31.4851C158.417 26.4839 162.423 24.0819 162.6 23.9658C160.348 20.5696 156.841 20.1049 155.592 20.0525C152.605 19.739 149.769 21.8611 148.252 21.8611C146.742 21.8611 144.407 20.0936 141.93 20.1411C138.673 20.1948 135.673 22.0909 134.001 25.0961C130.618 31.1417 133.134 40.0973 136.43 45.0011C138.041 47.4018 139.96 50.0948 142.479 49.9974C144.911 49.9 145.828 48.3799 148.762 48.3799C151.697 48.3799 152.519 49.9974 155.087 49.9487C157.7 49.9 159.354 47.5018 160.951 45.0936C162.8 42.3095 163.562 39.614 163.606 39.4779C163.549 39.4454 158.517 37.4656 158.463 31.4851Z",
    fill: "#CCD0D2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_9876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_508_9876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(64 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.b1ac635e333b031137b402cb1faa8753.svg";
export { ForwardRef as ReactComponent };